'use strict';

var angular = require('angular');
var CorePricing = require('../v2/components/core-pricing/core-pricing.jsx');
var dependencies = ['ui.router'];
module.exports = angular.module('AVRO.FaresOptimizer.HybridCorePricing', dependencies).config(require('./config/HybridCorePricingConfig')).component('corepricing', require('react2angular').react2angular(CorePricing["default"], [], ['App']));